import type { ReactNode } from "react";
import React from "react";
import ErrorPage from "src/ui/components/SentryBoundary/ErrorPage";
import reportErrorSentry from "src/lib/reportErrorSentry";

interface ErrorProps {
  children: ReactNode;
}
interface ErrorState {
  hasError: boolean;
}

export default class CustomErrorBoundary extends React.Component<
  ErrorProps,
  ErrorState
> {
  constructor(props: ErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    reportErrorSentry(error);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorPage data-testid="errorPage" />;
    }
    return this.props.children;
  }
}
